import { Component, EventEmitter, Output, signal, HostListener, Inject, PLATFORM_ID, OnInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterLink } from '@angular/router';
import { CalendlyService } from '../../services/calendly.service';

@Component({
  selector: 'app-header',
  imports: [RouterLink],
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class Header implements OnInit {
  @Output() private showMenu = new EventEmitter<void>();

  /** true once scrolled roughly past the hero — drives the solid nav state */
  protected solid = signal(false);

  constructor(
    private calendly: CalendlyService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.updateSolid();
    }
  }

  @HostListener('window:scroll')
  onScroll() {
    this.updateSolid();
  }

  private updateSolid() {
    if (!isPlatformBrowser(this.platformId)) return;
    // Solidify once the viewport has scrolled ~past a full-height hero.
    const threshold = window.innerHeight * 0.9;
    const next = window.scrollY > threshold;
    if (next !== this.solid()) {
      this.solid.set(next);
    }
  }

  openMenu() {
    this.showMenu.emit();
  }

  scheduleCall() {
    this.calendly.openPopup().catch(() => {});
  }
}
